export { ReactComponent as ticketCoinIcon } from './ticket-coin.svg';
export { ReactComponent as leftArrowCircleFilledIcon } from './left-arrow-circle-filled.svg';
